import { useDispatch, useSelector } from 'react-redux';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { TableCell, IconButton, Tooltip } from '@mui/material';
import { lockUser } from '../../../reducers/AdminUserMgtReducer';
import { fetchEditDetails } from '../../../reducers/userEditForm';
import { openModal } from '../../../reducers/modal';
import { modalTypes } from '../../modal/Modal';

const ActionCell = ({ userId }) => {
  const dispatch = useDispatch();
  const lockStatus = useSelector((state) => state.actionsReducer.userDetails.find((user) => user.user_id === userId).locked);

  const currentUser_id = useSelector(({ currentUser: { user_id } }) => ({ user_id }));

  const adminIsEditingOwn = (userId === currentUser_id.user_id);

  const handleLockClick = () => {
    dispatch(lockUser(userId));
  };

  const handleEditClick = () => {
    dispatch(fetchEditDetails(userId));
    dispatch(openModal({ type: modalTypes.EDIT_MODAL }));
  };

  const handleDeleteClick = () => {
    dispatch(openModal({ type: modalTypes.CONFIRM_MODAL, data: userId }));
  };

  return (
    <TableCell
      align="left"
      sx={{ color: '#22467F', padding: '4px', width: 'auto', whiteSpace: 'nowrap', overflow: 'hidden' }}
    >
      <Tooltip title={adminIsEditingOwn ? 'You are not permitted to lock own account' : 'Lock/Unlock user account'}>
        <span>
          <IconButton
            disabled={adminIsEditingOwn}
            onClick={handleLockClick}
            sx={{
              color: lockStatus ? '#c5221f' : '#3bc51f',
              '&.Mui-disabled': {
                color: '#5e5e5f',
              },
              size: 'small',
            }}
          >
            {lockStatus ? (
              <LockIcon />
            ) : (
              <LockOpenIcon />
            )}
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Edit user details">
        <IconButton
          sx={{
            color: '#22467F',
            size: 'small',
          }}
          onClick={handleEditClick}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={adminIsEditingOwn ? 'You are not permitted to delete own account' : 'Delete User Account'}>
        <span>
          <IconButton
            disabled={adminIsEditingOwn}
            sx={{
              color: '#22467F',
              '&.Mui-disabled': {
                color: '#5e5e5f',
              },
              size: 'small',
            }}
            onClick={handleDeleteClick}
          >
            <DeleteIcon />
          </IconButton>
        </span>
      </Tooltip>
    </TableCell>
  );
};
export default ActionCell;
